class ProductTabs extends HTMLElement {
  constructor() {
    super();

    this.tab = this.querySelectorAll(".tab-title");
    this.tabContents = this.querySelector(".tabs-contents");
    this.tabContent = this.querySelectorAll(".tab-content");
    this.link = this.querySelectorAll(".toggleLink");
    this.readMore = this.querySelectorAll("[data-show-more-toogle]");
    this.tabClose = this.querySelectorAll(".pdViewTab-close");

    this.isVerticalPopup = this.dataset.vertical === "sidebar";
    this.isVerticalSidebarMobile =
      this.dataset.verticalMobile === "sidebar-mobile";

    this.tab.forEach((tab) => {
      tab.addEventListener("click", this.tabActive.bind(this));
    });

    this.link.forEach((link) => {
      link.addEventListener("click", this.tabToggle.bind(this));
    });

    document.addEventListener("click", (event) => {
      const showMoreButton = event.target.closest(
        "[data-show-more-toogle]"
      );

      const closeButton = event.target.closest(".pdViewTab-close");

      if (showMoreButton && this.contains(showMoreButton)) {
        this.readMoreReadLess(event);
        return;
      }

      if (closeButton && this.contains(closeButton)) {
        this.productTabClose(event);

        if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
          this.handleVerticalPopupClose(event);
        }
      }
    });

    if (this.isVerticalPopup || this.isVerticalSidebarMobile) {
      const backgroundOverlay = document.querySelector(
        ".background-overlay"
      );

      backgroundOverlay?.addEventListener(
        "click",
        this.onBackgroundClick.bind(this)
      );
    }

    setTimeout(() => {
      if (window.innerWidth <= 550) return;

      const descriptionContent = this.querySelector(
        "#tab-description-mobile"
      );

      if (!descriptionContent) return;

      const showMoreContainer =
        descriptionContent.querySelector(".tab-showMore");

      if (!showMoreContainer) return;

      const tabHeight = descriptionContent.offsetHeight;
      const maxHeight = parseInt(
        showMoreContainer.dataset.desMax,
        10
      );

      if (!Number.isNaN(maxHeight) && tabHeight < maxHeight) {
        showMoreContainer.remove();
      }
    });
  }

  /**
   * Retorna o conteúdo relacionado ao botão da tab.
   */
  getToggleContent(toggleLink) {
    if (!toggleLink) return null;

    const toggleTitle = toggleLink.parentElement;

    if (!toggleTitle) return null;

    return toggleTitle.nextElementSibling;
  }

  /**
   * Fecha todas as outras tabs dentro deste mesmo componente,
   * mantendo apenas a tab selecionada aberta.
   */
  closeOtherTabs(activeLink) {
    this.link.forEach((link) => {
      if (link === activeLink) return;

      const content = this.getToggleContent(link);

      if (!content) return;

      const linkIsOpen =
        link.classList.contains("is-open") ||
        link.classList.contains("show-mobile");

      const contentIsOpen =
        content.classList.contains("is-show") ||
        content.style.display === "block";

      if (!linkIsOpen && !contentIsOpen) return;

      link.classList.remove("is-open");
      link.classList.remove("show-mobile");

      const isPopupMobile =
        link.classList.contains("popup-mobile") &&
        window.innerWidth <= 551;

      const isDesktopSidebar =
        this.isVerticalPopup &&
        window.innerWidth > 550;

      const isMobileSidebar =
        link.classList.contains("sidebar-mobile") &&
        window.innerWidth <= 550;

      if (
        isPopupMobile ||
        isDesktopSidebar ||
        isMobileSidebar
      ) {
        content.classList.remove("is-show");
      } else {
        $(content)
          .stop(true, true)
          .slideUp("slow");
      }
    });
  }

  tabActive(event) {
    event.preventDefault();
    event.stopPropagation();

    const currentTab = event.currentTarget;
    const href = currentTab.getAttribute("href");

    if (!href) return;

    const id = href.replace("#", "");

    const shakingButton = document.querySelector(
      ".an-horizontal-shaking"
    );

    if (!currentTab.classList.contains("is-open")) {
      this.tab.forEach((tab) => {
        tab.classList.remove("is-open");
      });

      currentTab.classList.add("is-open");

      this.tabContents?.classList.add("is-show");

      shakingButton?.classList.add("open-tab-content");

      this.tabContent.forEach((content) => {
        if (content.getAttribute("id") === id) {
          content.classList.add("is-active");
        } else {
          content.classList.remove("is-active");
        }
      });
    }

    if (currentTab.classList.contains("open-tab-content")) {
      shakingButton?.classList.remove("open-tab-content");
    }

    this.checkTabShowMore(id);
  }

  tabToggle(event) {
    event.preventDefault();
    event.stopPropagation();

    const currentLink = event.currentTarget;
    const currentContent =
      this.getToggleContent(currentLink);

    if (!currentContent) return;

    const isMobile = window.innerWidth <= 551;

    const isPopupMobile =
      currentLink.classList.contains("popup-mobile") &&
      isMobile;

    /*
     * Tabs em formato de popup no mobile.
     */
    if (isPopupMobile) {
      if (currentContent.classList.contains("is-show")) {
        currentLink.classList.remove("is-open");
        currentContent.classList.remove("is-show");
      } else {
        this.closeOtherTabs(currentLink);

        currentLink.classList.add("is-open");
        currentContent.classList.add("is-show");
      }

      return;
    }

    /*
     * Tab configurada para iniciar aberta no mobile.
     */
    if (
      isMobile &&
      currentLink.classList.contains("show-mobile")
    ) {
      currentLink.classList.remove("is-open");
      currentLink.classList.remove("show-mobile");

      $(currentContent)
        .stop(true, true)
        .slideUp("slow");

      return;
    }

    /*
     * Fecha a própria tab quando ela já está aberta.
     */
    if (currentLink.classList.contains("is-open")) {
      currentLink.classList.remove("is-open");

      const isDesktopSidebar =
        this.isVerticalPopup &&
        window.innerWidth > 550;

      const isMobileSidebar =
        currentLink.classList.contains("sidebar-mobile") &&
        window.innerWidth <= 550;

      if (isDesktopSidebar || isMobileSidebar) {
        currentContent.classList.remove("is-show");

        document.body.classList.remove(
          "tab-popup-show"
        );

        document.body.classList.remove(
          "tab-popup-sidebar-show"
        );
      } else {
        $(currentContent)
          .stop(true, true)
          .slideUp("slow");
      }

      return;
    }

    /*
     * Antes de abrir a nova tab, fecha todas as demais.
     */
    this.closeOtherTabs(currentLink);

    currentLink.classList.add("is-open");

    const isDesktopSidebar =
      this.isVerticalPopup &&
      window.innerWidth > 550;

    const isMobileSidebar =
      currentLink.classList.contains("sidebar-mobile") &&
      window.innerWidth <= 550;

    if (isDesktopSidebar || isMobileSidebar) {
      document.body.classList.add(
        "tab-popup-sidebar-show"
      );

      currentContent.classList.add("is-show");

      document.body.classList.add(
        "tab-popup-show"
      );
    } else {
      $(currentContent)
        .stop(true, true)
        .slideDown("slow");
    }
  }

  readMoreReadLess(event) {
    event.preventDefault();
    event.stopPropagation();

    const currentButton = event.target.closest(
      "[data-show-more-toogle]"
    );

    if (!currentButton) return;

    const href = currentButton.getAttribute("href");

    if (!href) return;

    const id = href.replace("#", "");

    const textShowMore = currentButton.getAttribute(
      "data-show-more-text"
    );

    const textShowLess = currentButton.getAttribute(
      "data-show-less-text"
    );

    const showMoreContainer =
      currentButton.closest(".tab-showMore");

    if (!showMoreContainer) return;

    const desMax =
      showMoreContainer.dataset.desMax;

    const targetContent =
      document.getElementById(id);

    if (!targetContent) return;

    if (currentButton.classList.contains("is-less")) {
      showMoreContainer.classList.remove("is-less");
      showMoreContainer.classList.add("is-show");

      currentButton.classList.remove("is-less");
      currentButton.classList.add("is-show");

      currentButton.innerText = textShowMore;

      targetContent.style.maxHeight = `${desMax}px`;

      this.tabContents?.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "nearest",
      });
    } else {
      showMoreContainer.classList.remove("is-show");
      showMoreContainer.classList.add("is-less");

      currentButton.classList.remove("is-show");
      currentButton.classList.add("is-less");

      currentButton.innerText = textShowLess;

      targetContent.style.maxHeight = "unset";
    }
  }

  productTabClose(event) {
    event.preventDefault();
    event.stopPropagation();

    this.tabContents?.classList.remove("is-show");

    this.tab.forEach((tab) => {
      tab.classList.remove("is-open");
    });

    this.tabContent.forEach((content) => {
      content.classList.remove("is-active");
    });

    document
      .querySelector(".an-horizontal-shaking")
      ?.classList.remove("open-tab-content");

    if (window.innerWidth <= 551) {
      const toggleContent =
        event.target.closest(".toggle-content");

      toggleContent?.classList.remove("is-show");
    }
  }

  checkTabShowMore(id) {
    if (window.innerWidth <= 550) return;

    const currentContent =
      document.getElementById(id);

    if (!currentContent) return;

    const showMoreContainer =
      currentContent.querySelector(".tab-showMore");

    if (!showMoreContainer) return;

    const tabHeight = currentContent.offsetHeight;

    const maxHeight = parseInt(
      showMoreContainer.dataset.desMax,
      10
    );

    if (!Number.isNaN(maxHeight) && tabHeight < maxHeight) {
      showMoreContainer.remove();
    }
  }

  onBackgroundClick(event) {
    if (
      event.target.closest(".toggle-content.is-show")
    ) {
      return;
    }

    this.link.forEach((link) => {
      link.classList.remove("is-open");
    });

    this.querySelectorAll(
      ".toggle-content.is-show"
    ).forEach((content) => {
      content.classList.remove("is-show");
    });

    document.body.classList.remove(
      "tab-popup-show"
    );

    document.body.classList.remove(
      "tab-popup-sidebar-show"
    );
  }

  handleVerticalPopupClose(event) {
    const closeButton =
      event.target.closest(".pdViewTab-close");

    if (!closeButton) return;

    const toggleContent =
      closeButton.closest(".toggle-content");

    const tabContent =
      closeButton.closest(".tab-content");

    toggleContent?.classList.remove("is-show");

    tabContent
      ?.querySelector(".toggleLink")
      ?.classList.remove("is-open");

    document.body.classList.remove(
      "tab-popup-show"
    );

    document.body.classList.remove(
      "tab-popup-sidebar-show"
    );
  }
}

if (!customElements.get("product-tab")) {
  customElements.define("product-tab", ProductTabs);
}

